import {setChangeDateException} from '@sparbanken-syd/loan-renewal-be'

export const HIGH_INTEREST_TITLE = 'Högt värde'
export const HIGH_INTEREST_TEXT = 'En hög rabatt har angetts, kontrollera registrering.'
export const HIGH_INTEREST_LIMIT = 3

export const HANDLAGGARE = 'renewalToolViewer'
export const KUNDCENTER = 'renewalToolAdmin'

const SPECIAL_LOANS_AUGUST_2026 = ['5251802988',
  '5252078174',
  '5251682612',
  '5252077804',
  '5251797097',
  '5251910047',
  '5251931357',
  '5252078166',
  '5251682596',
  '5251540018',
  '5251910039',
  '5251682604',
  '5251636675',
  '5251585310',
  '5251741970',
  '5251477005',
  '5251799101',
  '5251577424',
  '5251767280',
  '5251679246',
  '5251752845',
  '5251676028',
  '5251788260',
  '5251682000',
  '5252086482',
  '5252075493',
  '5251425582',
  '5251904743',
  '5251799606',
  '5251544150',
  '5251904727',
  '5251922935',
  '5251755699',
  '5251791538',
  '5252079214',
  '5251748892',
  '5251678412',
  '5251904735',
  '5251680574',
  '5251741707',
  '5251904719',
  '5250463428',
  '5251475421',
  '5251679725',
  '5251083159',
  '5251741715',
  '5251564067',
  '5250975199',
  '5251578323',
  '5251754155',
  '5251579206',
  '5251782891',
  '5251473020',
  '5251679709',
  '5251481338',
  '5251577846',
  '5251782883',
  '5252086193',
  '5251760392',
  '5251782909',
  '5252086177',
  '5251667209',
  '5251756713',
  '5251586144',
  '5251576475',
  '5251574264',
  '5251575659',
  '5252086185',
  '5251673835',
  '5251923503',
  '5251581467',
  '5251756739',
  '5251682893',
  '5251576467',
  '5251924642',
  '5251759436',
  '5251749031',
  '5251751870',
  '5251682927',
  '5251799820',
  '5251759428',
  '5251931787',
  '5251670765',
  '5251682943',
  '5251578737',
  '5251929021',
  '5251448154',
  '5251914718',
  '5251931795',
  '5251803903',
  '5251681671',
  '5251820030',
  '5251576483',
  '5251795190',
  '5251691167',
  '5251578729',
  '5251802905',
  '5251790811',
  '5252081194',
  '5252078653',
  '5251931803',
  '5251670757',
  '5252080568',
  '5251681689',
  '5251820022',
  '5251694179',
  '5252078661',
  '5251914726',
  '5252082234',
  '5252076020',
  '5251929880',
  '5251748934',
  '5251681663',
  '5251797279',
  '5251691159',
  '5251578711',
  '5251795414',
  '5252076012',
  '5251591326',
  '5251807235',
  '5251753900',
  '5251682851',
  '5251587639',
  '5251586581',
  '5251591318',
  '5251583489',
  '5251578745',
  '5251777081',
  '5252078307',
  '5251682687',
  '5251727672',
  '5251677570',
  '5251688601',
  '5252078315',
  '5251679279',
  '5251682695',
  '5251748488',
  '5251679261',
  '5251570932',
  '5251805759',
  '5251579677',
  '5251674460',
  '5251741491',
  '5252077648',
  '5251583679',
  '5251564745',
  '5251800941',
  '5251727607',
  '5251761812',
  '5251804687',
  '5251802723',
  '5251761838',
  '5251920962',
  '5251481312',
  '5251576830',
  '5252079354',
  '5252081756',
  '5251687041',
  '5251792551',
  '5251794177',
  '5251799994',
  '5251576848',
  '5251681614',
  '5252081780',
  '5251589353',
  '5251652755',
  '5252081467',
  '5252084867',
  '5251746466',
  '5251754817',
  '5251594262',
  '5251691324',
  '5251579842',
  '5251756382',
  '5251680327',
  '5251582242',
  '5251574488',
  '5251922182',
  '5251691316',
  '5251562244',
  '5251756390',
  '5252081475',
  '5251574447',
  '5251927868',
  '5251922844',
  '5251570114',
  '5251922133',
  '5251228390',
  '5251633094',
  '5251585880',
  '5252066294',
  '5251794607',
  '5251574462',
  '5251798251',
  '5251581731',
  '5251922851',
  '5252077549',
  '5251750948',
  '5251574470',
  '5250193421',
  '5251685797',
  '5251686316',
  '5251750930',
  '5251679675',
  '5251921853',
  '5251783238',
  '5251686324',
  '5251584560',
  '5251675848',
  '5251756481',
  '5251790738',
  '5251750955',
  '5251581871',
  '5251790423',
  '5251669957',
  '5251552534',
  '5251790415',
  '5251587316',
  '5251618475',
  '5251684220',
  '5251581996',
  '5251815816',
  '5251679584',
  '5251693197',
  '5251736194',
  '5251918594',
  '5251796883',
  '5251684238',
  '5251744040',
  '5251815824',
  '5251488820',
  '5251736210',
  '5251602925',
  '5251587266',
  '5251578356',
  '5251917281',
  '5251683578',
  '5251885918',
  '5251922752',
  '5251727680',
  '5251585575',
  '5251929039',
  '5251674494',
  '5251585013',
  '5251727698',
  '5252050454',
  '5252077267',
  '5251801006',
  '5251796842',
  '5252077028',
  '5251790761',
  '5252077002',
  '5251790753',
  '5251790779',
  '5251754619',
  '5251927371',
  '5251927363',
  '5252082937',
  '5251755871',
  '5251927421',
  '5251927439'
]

// This can and should be removed after Sep 10th 2026
setChangeDateException('2026-08-25', SPECIAL_LOANS_AUGUST_2026)
